module.exports = __webpack_public_path__ + "img/wlv_19.9a93a95a.png";